import { Observable } from 'rxjs';
import { QualityControl } from '../entities/quality-control.entity';
import { QcValidations } from '../entities/quality-control-validation.entity';
import { QcAsset } from '../entities/quality-control-asset.entity';
import { QcDocument } from '../entities/quality-control-document.entity';
import { EditAssetItemDto } from '../../application/dtos/edit-assets.dto';
import { EditAppraisalValidationDto, EditAssetValidationDto } from '../../application/dtos/edit-validations.dto';
import { CreateOrderWithQualityControlDocumentDto } from 'app/modules/orders/application/dtos/create-order-with-quality-control.dto';

export interface QualityControlListPagedRequest {
  orderId: string;
  page: number;
  pageSize: number;
  orderField?: string;
  ascendingOrder: boolean;
  filter?: QualityControlListFilter;
}

export interface QualityControlListFilter {
  code?: string;
  status?: number;
  technicalUserIds?: string[];
  qualityControlResults?: number[];
  qualityControlStatus?: number[];
  createdAtFrom?: string;
  createdAtTo?: string;
  finishedAtFrom?: string;
  finishedAtTo?: string;
  portfolioIds?: string[];
  clientIds?: string[];
  orderCreatedAtFrom?: string;
  orderCreatedAtTo?: string;
  isCancelled?: boolean;
  appraisalCompany?: number;
}

export interface QualityControlGetListPagedRequest {
  page: number;
  pageSize: number;
  orderField?: string;
  ascendingOrder: boolean;
  filter?: QualityControlListFilter;
}

export interface QualityControlListPagedResponse {
  items: QualityControl[];
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalItemsCount: number;
}

export interface QcDocumentUpload {
  file: File;
  documentType: number;
  documentOrigin: number;
}

export interface QcDocumentListFilter {
  documentTypes?: number[];
  documentOrigin?: number[];
}

export interface QcDocumentListPagedRequest {
  qualityControlId: string;
  page: number;
  pageSize: number;
  orderField?: string;
  ascendingOrder: boolean;
  filter?: QcDocumentListFilter;
}

export interface OrderQcDocumentListPagedRequest {
  orderId: string;
  page: number;
  pageSize: number;
  orderField?: string;
  ascendingOrder: boolean;
  filter?: QcDocumentListFilter;
}

export interface QcDocumentListPagedResponse {
  items: QcDocument[];
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalItemsCount: number;
}

export abstract class QualityControlRepositoryPort {
  abstract getListPaged(request: QualityControlGetListPagedRequest): Observable<QualityControlListPagedResponse>;
  abstract getListPagedByOrder(request: QualityControlListPagedRequest): Observable<QualityControlListPagedResponse>;
  abstract getDetails(id: string): Observable<QualityControl>;
  abstract create(orderId: string, appraisalCompany?: number, appraisalPurpose?: number, documents?: CreateOrderWithQualityControlDocumentDto[]): Observable<string>;
  abstract update(qualityControlId: string, appraisalCompany?: number, appraisalPurpose?: number): Observable<void>;
  abstract getAssets(qualityControlId: string): Observable<QcAsset[]>;
  abstract editAssets(qualityControlId: string, assets: EditAssetItemDto[]): Observable<void>;
  abstract getValidations(qualityControlId: string): Observable<QcValidations>;
  abstract editValidations(qualityControlId: string, appraisalValidation: EditAppraisalValidationDto, assetValidations: EditAssetValidationDto[]): Observable<void>;
  abstract finishValidation(qualityControlId: string): Observable<void>;
  abstract startValidation(qualityControlId: string): Observable<void>;
  abstract assignTechnical(qualityControlId: string, userId: string): Observable<void>;
  abstract getQcDocuments(request: QcDocumentListPagedRequest): Observable<QcDocumentListPagedResponse>;
  abstract getQcDocumentsByOrder(request: OrderQcDocumentListPagedRequest): Observable<QcDocumentListPagedResponse>;
  abstract uploadQcDocuments(qualityControlId: string, documents: QcDocumentUpload[]): Observable<void>;
  abstract deleteQcDocument(documentId: string): Observable<void>;
}
